/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Final disposition of a playback session, derived from the end reason
 * and whether any playback occurred. Wire field: `fc`.
 */
export enum FailureClassification {
  SUCCESS = "SUCCESS",
  FAILURE_STARTUP = "FAILURE_STARTUP",
  FAILURE_PLAYBACK = "FAILURE_PLAYBACK",
  FAILURE_POLICY = "FAILURE_POLICY",
  FAILURE_NETWORK = "FAILURE_NETWORK",
  FAILURE_UNKNOWN = "FAILURE_UNKNOWN"
}
